export default __webpack_public_path__ + "static/media/aqua-coin.be92c596.png";